module.exports = __webpack_public_path__ + "media/audios/kid/lesson_11/audio_tpc11_recompensa-f6d9de6d1810f92f55c3536bb3c8a6c3.m4a";